import { useState } from 'react'
import { format } from 'date-fns'

import { Table } from 'components/Table'
import { ColumnsProps } from 'components/Table/Table'
import { ErrorModal } from '../ErrorModal'

import { ChargeData } from '../../../../types/ChargeData.types'

import { useTranslation } from 'react-i18next'

import * as S from './styled'

export type ChargeDataTableProps = {
  rows: ChargeData[]
}

export function ChargeDataTable({ rows = [] }: ChargeDataTableProps) {
  const { t } = useTranslation()
  const [errorModal, setErrorModal] = useState({
    open: false,
    errorMessages: null,
    fileName: ''
  })

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString)
      return format(date, 'dd/MM/yyyy HH:mm')
    } catch (error) {
      return dateString
    }
  }

  const handleErrorClick = (errorMessages: any, fileName: string) => {
    setErrorModal({
      open: true,
      errorMessages,
      fileName
    })
  }

  const handleCloseModal = () => {
    setErrorModal({
      open: false,
      errorMessages: null,
      fileName: ''
    })
  }

  const columns = (): ColumnsProps[] => [
    {
      name: 'createdAt',
      title: t('tables:datetime'),
      align: 'right'
    },
    {
      name: 'user',
      title: t('tables:user')
    },
    {
      name: 'fileName',
      title: t('tables:fileName')
    },
    {
      name: 'status',
      title: t('tables:status'),
      align: 'center'
    }
  ]

  // Formatando os dados para o componente Table
  const formattedRows = rows.map(each => {
    return {
      fileName: each.file?.filename ?? '',
      user: each.user?.email,
      createdAt: formatDate(each.createdAt),
      method: each.chargeMethod || each.method,
      status: (
        <S.StatusBadge
          status={each.status}
          clickable={each.status === 'error'}
          onClick={() => {
            if (each.status === 'error') {
              handleErrorClick(each.errorMessages, each.file?.filename || '')
            }
          }}
        >
          {each.status === 'success' ? t('common:success') : t('common:error')}
        </S.StatusBadge>
      )
    }
  })

  return (
    <S.Wrapper data-testid="ChargeDataTable">
      <Table columns={columns()} rows={formattedRows} />
      <ErrorModal
        open={errorModal.open}
        onClose={handleCloseModal}
        errorMessages={errorModal.errorMessages}
        fileName={errorModal.fileName}
      />
    </S.Wrapper>
  )
}
